import * as React from "react"
import Spacer from "../components/spacer"

const Article = ({ article, className, innerClassName }) => {
  return (
      <div className='single--article p40 flex flex-wrap bg-dark '>
        <div className='title-area w-100'>
          <p className={'m0 text-light h3 max-850'}>{article.title}</p> 
          <Spacer />
          <Spacer />
          <Spacer />
        </div>
        <div className='information flex w-100 mta'>
          <div className=''>
            <p className='m0 text-light'>{article.category?.name}</p>
            <p className='m0'>{article.meta?.publishedAt}</p>
          </div>
          <div className='w-50 mla flex align-bottom'>
            <p className="m0 mla">Visit <span className='underline text-light'>Live Website</span></p> 
          </div>
        </div>
      </div>
  )
}
export default Article
